import "./universal.css";
import Title from "../component/Title";
import Header from "../component/Header";
import MatchBox from "../component/MatchBox";
import Navigation from "../component/Navigation";
import { useParams } from "react-router-dom";
import MatchRating from "../data/MatchPrediction.json";
import styles from "../component/MatchPrediction.module.css";
import Updated from "../component/Updated";
import default_league from "../global/defaultLeague.json";

function MatchPrediction() {
  const params = useParams();
  let league;
  if (params.league === undefined) league = default_league;
  else league = params.league;
  let language;
  if (params.language === undefined) language = "kr";
  else language = params.language;

  const len = MatchRating[league] ? MatchRating[league].length : 0;

  return (
    <div className="whole-container">
      <Title service="match_prediction" language={language} />
      <div className="main-container">
        <div className="header-container">
          <Header service=" Match Prediction" league={league} />
          <div className="select-container">
            <Navigation
              service={"match_prediction"}
              league={league}
              language={language}
            />
          </div>
          <Updated className="web" update="prediction" />
        </div>
        <Updated className="mobile" update="prediction" />
        {MatchRating[league]
          ? MatchRating[league].map((_, idx) => {
              if (idx % 2)
                return (
                  <div key={(league, idx)} className={styles.MatchLine}>
                    <MatchBox
                      league={league}
                      match_num={idx - 1}
                      language={language}
                    />
                    <MatchBox
                      league={league}
                      match_num={idx}
                      language={language}
                    />
                  </div>
                );
              if (idx + 1 === len)
                return (
                  <div key={(league, idx)} className={styles.MatchLine}>
                    <MatchBox
                      league={league}
                      match_num={idx}
                      language={language}
                    />
                  </div>
                );
              return null;
            }): null}
      </div>
    </div>
  );
}

export default MatchPrediction;
